export const ActionTypes = {
  LOADING: "GENERATE_AI_CRITERIA_LOADING",
  ERROR: "GENERATE_AI_CRITERIA_ERROR",
  SUCCESS: "GENERATE_AI_CRITERIA_SUCCESS",
};
